import { DOMRouteHandler } from './DOMRouteHandler';
import { limitQuantityBasedOnVariant } from '../modules/puppy-pack';

export class TemplateProductPuppyPack extends DOMRouteHandler {
  static init(): void {
    limitQuantityBasedOnVariant();
  }
}
